<template>
  <div style="height: 100%; background: #ffffff; position: relative;z-index: 1">
    <div style="height: 100%; padding:15px">
      <div class="hierarchy_zoom_buttons">
        <v-btn icon small @mousedown="makeZoom(1.1)" @mouseup="clearZoom" @mouseleave="clearZoom"><v-icon>add</v-icon></v-btn>
        <br>
        <v-btn icon small @mousedown="makeZoom(0.9)" @mouseup="clearZoom" @mouseleave="clearZoom"><v-icon>remove</v-icon></v-btn>
        <br>
        <v-btn icon small @click="findMyself"><v-icon>person</v-icon></v-btn>
      </div>
      
      <div class="search-block">
        <span v-show="results_found>0">Найдено: <span>{{results_found}}</span></span>
        <b>Поиск:</b> <input type="search" id="mySearch" v-model="searchText">
        <v-btn icon small @click="navigateSearch('prev')"><v-icon>keyboard_arrow_left</v-icon></v-btn>
        <v-btn icon small @click="navigateSearch('next')"><v-icon>keyboard_arrow_right</v-icon></v-btn>
      </div>
      
      <div id="orgsheme" style="position: relative; height: 100%;" ref="orgsheme">
        <div id="myDiagramDiv" style="width: 100%; height: 100%;">
          <div class="text-xs-center">Загрузка оргсхемы...</div>
        </div>
        <div id="overview"></div>
        <div id="OrgSchemeContextMenu" ref="contCtxMenu" :style="{position: 'absolute', zIndex: 100, left:ctxCoords.x, top:ctxCoords.y} " v-show="showContCtx" tabindex="1" @blur="hideCtxMenu">
          <ul>
            <li id="show_info" class="org-ctxmenu" @click="showContainerInfo"><i class="mdi mdi-information"></i> <span>Информация о подразделении</span></li>
            <li id="node_prev" class="org-ctxmenu" @click="moveNode(null, 'before', null)" v-if="accesses.container_update"><i class="mdi mdi-arrow-left"></i> <span>Передвинуть назад</span></li>
            <li id="node_next" class="org-ctxmenu" @click="moveNode(null, 'after', null)" v-if="accesses.container_update"><i class="mdi mdi-arrow-right"></i> <span>Передвинуть вперед</span></li>
            <li id="edit" class="org-ctxmenu" @click="editContainer" v-if="accesses.container_update"><i class="mdi mdi-pencil"></i> <span>Редактировать</span></li>
            <li id="add_being" class="org-ctxmenu" @click="addPost" v-if="accesses.post_create"><i class="mdi mdi-account-plus"></i> <span>Добавить пост</span></li>
            <li id="add_group" class="org-ctxmenu" @click="addContainer" v-if="accesses.container_create"><i class="mdi mdi-account-multiple-plus"></i> <span>Добавить подразделение</span></li>
            <li id="delete_group" class="org-ctxmenu" @click="deleteContainer" v-if="accesses.container_delete"><i class="mdi mdi-close"></i> <span>Удалить подразделение</span></li>
          </ul>
        </div>
        <div id="OrgSchemePostContextMenu" ref="posCtxMenu" :style="{position: 'absolute', zIndex: 100, left:ctxCoords.x, top:ctxCoords.y} " v-show="showPostCtx" tabindex="1" @blur="hideCtxMenu">
          <ul>
            <p class="org-ctxmenu text-xs-center postTitle" v-if="selectedPost"><b>{{selectedPost.title}}</b></p>
            <li id="show_post_info" class="org-ctxmenu" @click="showPostInfo"><i class="mdi mdi-information"></i> <span>Информация о посте</span></li>
            <li id="move_prev" class="org-ctxmenu" @click="movePost('before')" v-if="accesses.post_update"><i class="mdi mdi-arrow-left"></i> <span>Передвинуть назад</span></li>
            <li id="move_next" class="org-ctxmenu" @click="movePost('after')" v-if="accesses.post_update"><i class="mdi mdi-arrow-right"></i> <span>Передвинуть вперед</span></li>
            <li id="editPost" class="org-ctxmenu" @click="editPost" v-if="accesses.post_update"><i class="mdi mdi-pencil"></i> <span>Редактировать пост</span></li>
            <li id="invite_to_post" class="org-ctxmenu" @click="openInviteForm" v-if="accesses.invite_access"><i class="mdi mdi-account-plus"></i> <span>Пригласить на пост</span></li>
            <li id="dismiss_post" class="org-ctxmenu" @click="dismissPost" v-if="accesses.dismiss_access"><i class="mdi mdi-account-remove"></i> <span>Уволить с поста</span></li>
            <li id="delete_post" class="org-ctxmenu" @click="deletePost" v-if="accesses.post_delete"><i class="mdi mdi-close"></i> <span>Удалить пост</span></li>
          </ul>
        </div>
      </div>
    </div>
    
    <v-dialog v-model="dialog" :max-width="formWidth">
      <component v-if="dialog" :is="currentForm" v-bind="formProps" @close-dialog="dialog=false" @change="changeOrgscheme"></component>
    </v-dialog>
  
  </div>
</template>

<script>
  const POST_SIZE = 5
  const POST_WIDTH = 270
  const CONTAINER_WIDTH = 420
  const SPARK_INTERVAL = 3
  const SPARK_STROKEWIDTH = 1
  const BASELINE_LENGTH = 75
  const DEFAULT_IMG_PATH = '/static/images/user_default.png'
  const NOUSER_IMG_PATH = '/static/images/blank_profile.png'
  const LOADING_IMG_PATH = '/static/images/hourglass_circle.png'
  
  import NewPostForm from './Forms/NewPostForm'
  import InviteForm from './Forms/InviteForm'
  import NewGroupForm from './Forms/NewGroupForm'
  import DeleteForm from './Forms/DeleteForm'
  import PostInfo from './Forms/PostInfo'
  
  import { mapState } from 'vuex'
  
  export default {
    name: 'Orgschema',
    
    computed:{
      ...mapState(`app/account`, ['postId']),
      accesses: function() {
        return this.$store.state.app.account.accesses['orgstructure'] || {}
      }
    },
    
    data(){
      return {
        tree: [],
        dialog: false,
        myDiagram: null,
        allowMove: false,
        zoomin: 0, zoomout: 0, current: 1, current_node: false,
        temp_result: {},
        currentForm: null,
        formProps: {},
        showPostCtx: false,
        showContCtx: false,
        ctxCoords: { x:'0',y:'0' },
        selectedPost: null,
        selectedContainer: null,
        zoomInterval: false,
        searchText:'',
        results_found: 0,
        formWidth: 1000,
      }
    },
    
    created() {
      this.allowMove = !!this.accesses.container_update
      this.$store.dispatch('orgstructure/getScheme').then( data => {
        this.tree = data.container_tree
        this.init()
      })
      
      this.$bus.$on('DMS.Orgstructure.Container.ChangePosition', data => {
        this.moveNode(data.node, data.mode, data.target)
      })
    },
  
    destroyed() {
      this.$bus.$off('DMS.Orgstructure.Container.ChangePosition')
    },
    
    methods: {
      init() {
        const $d = go.GraphObject.make;  // for conciseness in defining templates
        
        this.myDiagram =
          $d(go.Diagram, "myDiagramDiv", // must be the ID or reference to div
            {
              initialContentAlignment: go.Spot.Center,
              maxSelectionCount: 1, // users can select only one part at a time
              layout: $d(go.TreeLayout,
                {
                  treeStyle: go.TreeLayout.StyleLastParents,
                  arrangement: go.TreeLayout.ArrangementHorizontal,
                  // properties for most of the tree:
                  angle: 90,
                  layerSpacing: 35,
                  nodeSpacing: 30,
                  compaction: go.TreeLayout.CompactionNone,
                  // properties for the "last parents":
                  alternateAngle: 0,
                  alternateAlignment: go.TreeLayout.AlignmentStart,
                  alternateNodeIndent: 25,
                  alternateNodeIndentPastParent: 1,
                  alternateNodeSpacing: 20,
                  alternateLayerSpacing: 40,
                  alternateLayerSpacingParentOverlap: 1,
                  alternatePortSpot: new go.Spot(0, 0.5, 0, 0),
                  alternateChildPortSpot: go.Spot.Left,
                  sorting: go.TreeLayout.SortingAscending,
                  alternateSorting: go.TreeLayout.SortingAscending,
                  comparer: function(va, vb) {
                    let da = va.node.data;
                    let db = vb.node.data;
                    if (da.position < db.position) return -1;
                    if (da.position > db.position) return 1;
                    return 0;
                  },
                  alternateComparer: function(va, vb) {
                    let da = va.node.data;
                    let db = vb.node.data;
                    if (da.position < db.position) return -1;
                    if (da.position > db.position) return 1;
                    return 0;
                  },
                }),
              "undoManager.isEnabled": true, // enable undo & redo
              allowMove: this.allowMove,
              "toolManager.hoverDelay": 200,
              "toolManager.toolTipDuration": 5000,
              "InitialLayoutCompleted": (e) => {
                let id = 0
                this.tree.map( container => {
                  container.posts.map( arr => {
                    arr.map( post => {
                      if( post.key===this.postId ) id = container.key
                    })
                  })
                })
                const node = this.myDiagram.findNodeForKey( id );
                if( node !== null ) this.myDiagram.commandHandler.scrollToPart( node );
  
                this.updatePosts()
              },
            });
      
        // this is used to determine feedback during drags
        function mayWorkFor(node1, node2) {
          if (!(node1 instanceof go.Node)) return false;  // must be a Node
          if (node1 === node2) return false;  // cannot work for yourself
          if (node2.isInTreeOf(node1)) return false;  // cannot work for someone who works for you
          return true;
        }
        
        // This function provides a common style for most of the TextBlocks.
        // Some of these values may be overridden in a particular TextBlock.
        function textStyle(bold=' ') {
          return {font: `${bold} 9pt Segoe UI,sans-serif`};
        }
        
        // define the Node template
        this.myDiagram.nodeTemplate =
          $d(go.Node, "Auto",
            { // handle dragging a Node onto a Node to (maybe) change the reporting relationship
              mouseDragEnter: function (e, node, prev) {
                if(e.diagram.allowMove){
                  const selnode = node.diagram.selection.first();
                  if (!mayWorkFor(selnode, node)) return;
                  const shape = node.findObject("SHAPE");
                  if (shape) {
                    shape._prevFill = shape.fill;  // remember the original brush
                    shape.fill = "darkred";
                  }
                }
              },
              mouseDragLeave: function (e, node, next) {
                const shape = node.findObject("SHAPE");
                if (shape && shape._prevFill) {
                  shape.fill = shape._prevFill;  // restore the original brush
                }
              },
              mouseDrop: (e, node) => {
                if(e.diagram.allowMove){
                  const selnode = node.diagram.selection.first();  // assume just one Node in selection
                  if (mayWorkFor(selnode, node)) {
                    // find any existing link into the selected node
                    const link = selnode.findTreeParentLink();
                    if (link !== null) {  // reconnect any existing link
                      link.fromNode = node;
                    } else {  // else create a new link
                      this.myDiagram.toolManager.linkingTool.insertLink(node, node.port, selnode, selnode.port);
                    }
                    this.$store.dispatch('orgstructure/updateContainer', {
                      id: selnode.data.key,
                      data: {parent_id:node.data.key}
                    })
                  }
                }
              }
            },
            // for sorting, have the Node.text be the data.name
            new go.Binding("text", "name"),
            // bind the Part.layerName to control the Node's layer depending on whether it isSelected
            new go.Binding("layerName", "isSelected", function (sel) {
              return sel ? "Foreground" : "";
            }).ofObject(),
            
            // define the node's outer shape
            $d(go.Shape, "RoundedRectangle",
              {
                name: "SHAPE",
              },
              new go.Binding("fill", "color"),
              new go.Binding("stroke", "stroke"),
              new go.Binding("strokeWidth", "strokeWidth")),
            
            $d(go.Panel, "Horizontal",
              // define the panel where the text will appear
              $d(go.Panel, "Table",
                {
                  name: "TableContainer",
                  margin: new go.Margin(6, 6, 6, 6),
                  defaultAlignment: go.Spot.Left,
                },
                new go.Binding("width", "is_container", function (v) {
                  return ( v === 1 ) ? CONTAINER_WIDTH : POST_WIDTH;
                }),
                
                // Если нужно зафиксировать у всех одинаковую ширину текста, нужно вместо WrapFit установить wrap: go.TextBlock.WrapDesiredSize
                $d(go.TextBlock, textStyle('bold'),
                  {
                    name: "TEXT",
                    row: 0, column: 0,
                    isMultiline: true,
                    wrap: go.TextBlock.WrapDesiredSize,
                    margin: new go.Margin(0, 5, 5, 0),
                    width: CONTAINER_WIDTH-30
                  },
                  new go.Binding("text", "title"),
                  new go.Binding("stroke", "color", function(v){return is_dark(v)})
                ),
                $d(go.Panel, "Vertical",
                  {
                    background: "transparent",
                    defaultAlignment: go.Spot.Right,
                    row: 0, column: 1,
                    cursor: "pointer",
                    margin : new go.Margin( 0, 0, 0, 0 ),
                    contextClick: this.openContCtx,
                    click: this.containerClick
                  },
                  $d(go.Shape,
                    {
                      margin : new go.Margin(2,2,2,2),
                      width : 15, height: 11,
                      strokeWidth: 2.5,
                      geometryString: "F M218,25L250,25 M218,50 L250,50 M218,75 L250,75",
                    },
                    {
                      toolTip:  // define a tooltip for each node that displays the color as text
                        $d(go.Adornment, "Auto",
                          $d(go.Shape, "RoundedRectangle", { fill: "#000" }),
                          $d(go.TextBlock, { margin: 2, text: 'Открыть контестное меню подразделения', stroke:'#FFF' })
                        )  // end of Adornment
                    },
                  ),
                ),
                
                $d("PanelExpanderButton", "EMPLOYEES",  // name of the object to make visible or invisible
                  {
                    row: 2, column: 1,
                    alignment: go.Spot.Right, alignmentFocus: go.Spot.Right,
                    margin: new go.Margin(5, 0, 0, 0)
                  },
                  new go.Binding("visible", "posts", function(v){ return v.length>0 })
                ),
  
                $d(go.Panel, "Table",
                  {
                    row: 3, column: 0, columnSpan: 2,
                    name: "EMPLOYEES",
                    width: CONTAINER_WIDTH,
                    itemTemplate:
                      $d(go.Panel, "TableRow",
                        $d(go.Panel, "Spot",
                          { scale: 2, column: 0, margin: new go.Margin(3, 0, 3, 0) },
                          $d(go.Panel, "Spot",
                            { isClipping: true, contextClick: this.openPostCtx, click: this.postClick  },
                            new go.Binding("visible", "", function(e) { return !!e[0]} ),
                            new go.Binding("params", "", function(e) {return e[0]} ),
                            $d(go.Shape, "Circle", { width: 25, strokeWidth: 0, fill: 'gray' } ),
                            $d(go.Picture,
                              { width: 25, height: 25 },
                              new go.Binding("source", "", function(e){
                                if(e[0].photo) {
                                  return e[0].photo
                                } else if(e[0].account_id==null){
                                  return NOUSER_IMG_PATH
                                } else {
                                  return e[0].form_id ? DEFAULT_IMG_PATH : LOADING_IMG_PATH
                                }
                              })
                            ),
                          ),
                          $d(go.TextBlock,
                            {
                              font: `4pt Segoe UI,sans-serif`,
                              isMultiline: true,
                              alignment: new go.Spot(0.5, 1.25),
                              textAlign: "center",
                              width: 36,
                              height: 11,
                              wrap: go.TextBlock.WrapDesiredSize,
                            },
                            new go.Binding("stroke", "", function(e, obj){ return is_dark(obj.part.data.color)} ),
                            new go.Binding("text", "", function(e, obj) {return e[0].title})
                          ),
                          {
                            toolTip:  // define a tooltip for each node that displays the color as text
                              $d(go.Adornment, "Auto",
                                $d(go.Shape, "RoundedRectangle", { fill: "#000" }),
                                $d(go.TextBlock, { margin: 2, stroke:'#FFF' },
                                  new go.Binding("text", "", function(e, obj) {return e[0].title+' '+e[0].fullname })
                                ),
                                new go.Binding("visible", "", function(e) { return !!e[0]} ),
                              )  // end of Adornment
                          },
                        ),
                        $d(go.Panel, "Spot",
                          { scale: 2, column: 1, margin: new go.Margin(3, 0, 3, 0) },
                          $d(go.Panel, "Spot",
                            { isClipping: true, contextClick: this.openPostCtx, click: this.postClick },
                            new go.Binding("visible", "", function(e) {return !!e[1]} ),
                            new go.Binding("params", "", function(e) {return e[1]} ),
                            $d(go.Shape, "Circle", { width: 25, strokeWidth: 0, fill: 'gray' } ),
                            $d(go.Picture,
                              { width: 25, height: 25 },
                              new go.Binding("source", "", function(e){
                                if(e[1].photo) {
                                  return e[1].photo
                                } else if(e[1].account_id==null){
                                  return NOUSER_IMG_PATH
                                } else {
                                  return e[1].form_id ? DEFAULT_IMG_PATH : LOADING_IMG_PATH
                                }
                              })
                            ),
                          ),
                          $d(go.TextBlock,
                            {
                              font: `4pt Segoe UI,sans-serif`,
                              isMultiline: true,
                              alignment: new go.Spot(0.5, 1.25),
                              textAlign: "center",
                              width: 36,
                              height: 11,
                              wrap: go.TextBlock.WrapDesiredSize,
                            },
                            new go.Binding("stroke", "", function(e, obj){ return is_dark(obj.part.data.color)} ),
                            new go.Binding("text", "", function(e, obj) {return e[1].title})
                          ),
                          {
                            toolTip:  // define a tooltip for each node that displays the color as text
                              $d(go.Adornment, "Auto",
                                $d(go.Shape, "RoundedRectangle", { fill: "#000" }),
                                $d(go.TextBlock, { margin: 2, stroke:'#FFF' },
                                  new go.Binding("text", "", function(e) { return e[1].title+' '+e[1].fullname })
                                ),
                                new go.Binding("visible", "", function(e) { return !!e[1]} ),
                              )  // end of Adornment
                          },
                        ),
                        $d(go.Panel, "Spot",
                          { scale: 2, column: 2, margin: new go.Margin(3, 0, 3, 0) },
                          $d(go.Panel, "Spot",
                            { isClipping: true, contextClick: this.openPostCtx, click: this.postClick  },
                            new go.Binding("visible", "", function(e) {return !!e[2]} ),
                            new go.Binding("params", "", function(e) {return e[2]} ),
                            $d(go.Shape, "Circle", { width: 25, strokeWidth: 0, fill: 'gray' } ),
                            $d(go.Picture,
                              { width: 25, height: 25 },
                              new go.Binding("source", "", function(e){
                                if(e[2].photo) {
                                  return e[2].photo
                                } else if(e[2].account_id==null){
                                  return NOUSER_IMG_PATH
                                } else {
                                  return e[2].form_id ? DEFAULT_IMG_PATH : LOADING_IMG_PATH
                                }
                              })
                            ),
                          ),
                          $d(go.TextBlock,
                            {
                              font: `4pt Segoe UI,sans-serif`,
                              isMultiline: true,
                              alignment: new go.Spot(0.5, 1.25),
                              textAlign: "center",
                              width: 36,
                              height: 11,
                              wrap: go.TextBlock.WrapDesiredSize,
                            },
                            new go.Binding("stroke", "", function(e, obj){ return is_dark(obj.part.data.color)} ),
                            new go.Binding("text", "", function(e, obj) {return e[2].title})
                          ),
                          {
                            toolTip:  // define a tooltip for each node that displays the color as text
                              $d(go.Adornment, "Auto",
                                $d(go.Shape, "RoundedRectangle", { fill: "#000" }),
                                $d(go.TextBlock, { margin: 2, stroke:'#FFF' },
                                  new go.Binding("text", "", function(e) { return e[2].title+' '+e[2].fullname })
                                ),
                                new go.Binding("visible", "", function(e) { return !!e[2]} ),
                              )  // end of Adornment
                          },
                        ),
                        $d(go.Panel, "Spot",
                          { scale: 2, column: 3, margin: new go.Margin(3, 0, 3, 0) },
                          $d(go.Panel, "Spot",
                            { isClipping: true, contextClick: this.openPostCtx, click: this.postClick  },
                            new go.Binding("visible", "", function(e) {return !!e[3]} ),
                            new go.Binding("params", "", function(e) {return e[3]} ),
                            $d(go.Shape, "Circle", { width: 25, strokeWidth: 0, fill: 'gray' } ),
                            $d(go.Picture,
                              { width: 25, height: 25 },
                              new go.Binding("source", "", function(e){
                                if(e[3].photo) {
                                  return e[3].photo
                                } else if(e[3].account_id==null){
                                  return NOUSER_IMG_PATH
                                } else {
                                  return e[3].form_id ? DEFAULT_IMG_PATH : LOADING_IMG_PATH
                                }
                              })
                            ),
                          ),
                          $d(go.TextBlock,
                            {
                              font: `4pt Segoe UI,sans-serif`,
                              isMultiline: true,
                              alignment: new go.Spot(0.5, 1.25),
                              textAlign: "center",
                              width: 36,
                              height: 11,
                              wrap: go.TextBlock.WrapDesiredSize,
                            },
                            new go.Binding("stroke", "", function(e, obj){ return is_dark(obj.part.data.color)} ),
                            new go.Binding("text", "", function(e, obj) {return e[3].title})
                          ),
                          {
                            toolTip:  // define a tooltip for each node that displays the color as text
                              $d(go.Adornment, "Auto",
                                $d(go.Shape, "RoundedRectangle", { fill: "#000" }),
                                $d(go.TextBlock, { margin: 2, stroke:'#FFF' },
                                  new go.Binding("text", "", function(e) { return e[3].title+' '+e[3].fullname })
                                ),
                                new go.Binding("visible", "", function(e) { return !!e[3]} ),
                              )  // end of Adornment
                          },
                        ),
                        $d(go.Panel, "Spot",
                          { scale: 2, column: 4, margin: new go.Margin(3, 0, 3, 0) },
                          $d(go.Panel, "Spot",
                            { isClipping: true, contextClick: this.openPostCtx, click: this.postClick  },
                            new go.Binding("visible", "", function(e) {return !!e[4]} ),
                            new go.Binding("params", "", function(e) {return e[4]} ),
                            $d(go.Shape, "Circle", { width: 25, strokeWidth: 0, fill: 'gray' } ),
                            $d(go.Picture,
                              { width: 25, height: 25 },
                              new go.Binding("source", "", function(e){
                                if(e[4].photo) {
                                  return e[4].photo
                                } else if(e[4].account_id==null){
                                  return NOUSER_IMG_PATH
                                } else {
                                  return e[4].form_id ? DEFAULT_IMG_PATH : LOADING_IMG_PATH
                                }
                              })
                            ),
                          ),
                          $d(go.TextBlock,
                            {
                              font: `4pt Segoe UI,sans-serif`,
                              isMultiline: true,
                              alignment: new go.Spot(0.5, 1.25),
                              textAlign: "center",
                              width: 36,
                              height: 11,
                              wrap: go.TextBlock.WrapDesiredSize,
                            },
                            new go.Binding("stroke", "", function(e, obj){ return is_dark(obj.part.data.color)} ),
                            new go.Binding("text", "", function(e, obj) {return e[4].title})
                          ),
                          {
                            toolTip:  // define a tooltip for each node that displays the color as text
                              $d(go.Adornment, "Auto",
                                $d(go.Shape, "RoundedRectangle", { fill: "#000" }),
                                $d(go.TextBlock, { margin: 2, stroke:'#FFF' },
                                  new go.Binding("text", "", function(e) { return e[4].title+' '+e[4].fullname })
                                ),
                                new go.Binding("visible", "", function(e) { return !!e[4]} ),
                              )  // end of Adornment
                          },
                        ),
                      )  // end of itemTemplate
                  },
                  new go.Binding("itemArray", "posts"),
                ),
  
                $d("TreeExpanderButton", {
                  row: 4,
                  column: 0,
                  width: 15,
                  alignment: go.Spot.Left,
                  alignmentFocus: go.Spot.Left,
                  margin: new go.Margin(5, 0, 0, 0)
                }),
                
              )  // end Table Panel
            ) // end Horizontal Panel
          );  // end Node
        
        function is_dark(color) {
          if (color.indexOf("#") === 0) {
            color = color.slice(1);
          }
          // convert 3-digit hex to 6-digits.
          if (color.length === 3) {
            color = color[0] + color[0] + color[1] + color[1] + color[2] + color[2];
          }
          if (color.length !== 6) {
            throw new Error("Invalid HEX color.");
          }
          const r = parseInt(color.slice(0, 2), 16);
          const g = parseInt(color.slice(2, 4), 16);
          const b = parseInt(color.slice(4, 6), 16);
          return (r * 0.299 + g * 0.587 + b * 0.114 < 186) ? "#FFFFFF" : "#000000";
        }
        
        // define the Link template
        this.myDiagram.linkTemplate = $d(go.Link, go.Link.Orthogonal,
          {corner: 5},
          $d(go.Shape, {strokeWidth: 4, stroke: "#00a4a4"}));  // the link shape
        
        // read in the JSON-format data from the "mySavedModel" element
        this.load();
        
        const myOverview = $d(go.Overview, overview,  // the HTML DIV element for the Overview
          {observed: this.myDiagram, contentAlignment: go.Spot.Center});
      },
      
      load() {
        this.myDiagram.model = go.Model.fromJson({
          "class": "go.TreeModel",
          "nodeDataArray": this.tree
        });
      },
  
      updatePosts(){
        let treeLength = this.tree.length
        let posts_ids = []
        let part_tree = []
        
        for(let i=0; i<treeLength; i++){
          let posts_object = {}
          part_tree[i]=this.tree[i]
          this.tree[i].posts.map( arr => {
            arr.map( post => {
              posts_object[post.key] = post
              if(post.account_id!=null) posts_ids.push(post.key)
            })
          })
          part_tree[i].posts_object = posts_object
          
          //Если в массиве набралось 30 id или это последний контейнер - отправить запрос на получение анкет
          if( posts_ids.length>=30 || i===(treeLength-1) ){
            let part_copy = part_tree.slice()
            this.$store.dispatch('app/anketa/orgschemeForms', {posts_ids}).then(response => {
              if(response && !Array.isArray(response)){
                part_copy.map( container => {
                  //Присвоить анкету посту в контейнере
                  for(let key in container.posts_object){
                    if(response[key]){
                      container.posts_object[key].form_id = response[key].form_id
                      container.posts_object[key].photo = (response[key].photo.indexOf('base64')<0 && response[key].photo.indexOf('http')<0 && response[key].photo.length>0) ? '/disk/d/'+response[key].photo : response[key].photo
                      container.posts_object[key].fullname = response[key].fullname
                    }
                  }
    
                  let posts = []
                  let row = 0, col = 0
                  for(let key1 in container.posts_object){
                    if(!posts[row]) posts[row] = []
                    posts[row].push(container.posts_object[key1])
                    col++
                    if(col>=POST_SIZE){
                      row++
                      col=0
                    }
                  }
                  let data = this.myDiagram.findNodeForKey( container.key ).data
                  this.myDiagram.startTransaction("update posts")
                  this.myDiagram.model.setDataProperty(data, "posts", posts)
                  this.myDiagram.commitTransaction("update posts")
                })
              }
            })
            posts_ids = []
            part_tree = []
          }
        }
      },
  
      openPostCtx(event, obj ){
        this.selectedPost = obj.params
        this.showPostCtx = true
        const mousePt = event.viewPoint
        this.ctxCoords = {
          x: mousePt.x + "px",
          y: mousePt.y + "px"
        }
        let el_dissmiss = document.getElementById('dismiss_post')
        if(el_dissmiss!=null) el_dissmiss.style.display = ( obj.params.account_id==null ) ? "none" : "block"
        
        let el_invite = document.getElementById('invite_to_post')
        if(el_invite!=null) el_invite.style.display = ( obj.params.account_id==null ) ? "block" : "none"
        
        let diagramWidth = this.$refs.orgsheme.offsetWidth
        let menuWidth = 150
        if(diagramWidth - mousePt.x < menuWidth + 20){
          this.ctxCoords.x = (mousePt.x - menuWidth) + "px"
        }
        
        this.$nextTick(() =>  this.$refs.posCtxMenu.focus())
      },
  
      openContCtx(event, obj ){
        this.myDiagram.select(obj.part)
        this.selectedContainer = obj.part.data
        this.showContCtx = true
  
        let el_delete = document.getElementById('delete_group')
        if(el_delete!=null) el_delete.style.display = ( obj.part.data.no_children && obj.part.data.posts.length===0 ) ? "block" : "none"
        
        const mousePt = event.viewPoint
        this.ctxCoords = {
          x: mousePt.x + "px",
          y: mousePt.y + "px"
        }
        
        let diagramWidth = this.$refs.orgsheme.offsetWidth
        let menuWidth = 255
        if(diagramWidth - mousePt.x < menuWidth){
          this.ctxCoords.x = (mousePt.x - menuWidth) + "px"
        }
        this.$nextTick(() =>  this.$refs.contCtxMenu.focus() )
      },
      
      hideCtxMenu(){
        this.showContCtx = false
        this.showPostCtx = false
        this.selectedPost = null
        this.selectedContainer = null
      },
      
      postClick(e, obj){
        this.dialog = false
        this.formWidth = 650
        this.currentForm = PostInfo
        this.formProps = {
          data: obj.params,
          type: 'post'
        }
        setTimeout( () => {
          this.dialog = true
        }, 300)
      },
  
      moveNode(node_id, mode, target = null){
        this.hideCtxMenu()
        let node = null
        if(node_id==null) {
          node = this.myDiagram.selection.first()
        } else {
          node = this.myDiagram.findNodeForKey( node_id )
        }
        if(node!=null){
          let siblings = node.findTreeParentNode().findTreeChildrenNodes()
          let it = siblings.iterator;
          let i = 0
  
          let node_pos = node.data.position
          let result = node.data.position
          let other_node = null
  
          if(mode==='before'){
            result = 0
            while(i<it.count){
              it.next()
              let current = it.value.data.position
              if(current < node_pos && current > result){
                result = current
                other_node = it.value
              }
              i++
            }
          } else {
            result = 100000000
            while(i<it.count){
              it.next()
              let current = it.value.data.position
              if(current > node_pos && current < result){
                result = current
                other_node = it.value
              }
              i++
            }
          }
          if(!other_node) return
          
          if(node_id==null){
            this.$store.dispatch('orgstructure/changeContainerPosition', {node: node.data.key, target: other_node.data.key, mode: mode})
          }
  
          if(target==null){
            this.myDiagram.startTransaction("swap nodes")
            this.myDiagram.model.setDataProperty(other_node.data, 'position', node_pos)
            this.myDiagram.model.setDataProperty(node.data, 'position', result)
            this.myDiagram.layout.invalidateLayout()
            this.myDiagram.commitTransaction("swap nodes")
          } else if(target===other_node.data.key){
            this.myDiagram.startTransaction("swap nodes")
            this.myDiagram.model.setDataProperty(other_node.data, 'position', node_pos)
            this.myDiagram.model.setDataProperty(node.data, 'position', result)
            this.myDiagram.layout.invalidateLayout()
            this.myDiagram.commitTransaction("swap nodes")
          }
        }
      },
      
      movePost(mode){
        let key = this.selectedPost.key
        this.hideCtxMenu()
        
        let node = this.myDiagram.selection.first()
        let posts = node.data.posts
        
        let row = null
        let index = null
  
        for(let i=0;i<posts.length;i++){
          for(let j=0;j<posts[i].length;j++){
            if (posts[i][j].key === key) {
              row = i
              index = j
              i = Number.MAX_VALUE
              break
            }
          }
        }
        
        let target_key = null
        
        if(mode==='before'){
          if(row===0 && index===0) return
          if(index===0 && row>0){
            let temp = posts[row-1][4]
            posts[row-1][4] = posts[row][index]
            posts[row][index] = temp
            target_key = temp.key
          } else if(index>0){
            let temp = posts[row][index-1]
            posts[row][index-1] = posts[row][index]
            posts[row][index] = temp
            target_key = temp.key
          }
        } else {
          if( (posts[row].length===index+1) && (posts.length === row+1) ) return
          if( (posts.length>row+1) && (index===4) ){
            let temp = posts[row+1][0]
            posts[row+1][0] = posts[row][index]
            posts[row][index] = temp
            target_key = temp.key
          } else {
            let temp = posts[row][index+1]
            posts[row][index+1] = posts[row][index]
            posts[row][index] = temp
            target_key = temp.key
          }
        }
  
        this.$store.dispatch('orgstructure/changePostPosition', {node: key, target: target_key, mode: mode})
        
        this.myDiagram.startTransaction("swap nodes")
        this.myDiagram.model.setDataProperty(node.data, 'posts', posts)
        this.myDiagram.commitTransaction("swap nodes")
        node.updateTargetBindings()
      },
  
      showPostInfo(){
        this.dialog = true;
        this.formWidth = 650
        this.currentForm = PostInfo
        this.formProps = {
          data: this.selectedPost,
          type: 'post'
        }
      },
  
      containerClick(event, obj ){
        this.formWidth = 650
        this.currentForm = PostInfo
        this.formProps = {
          data: obj.part.data,
          type: 'container'
        }
        setTimeout( () => {
          this.dialog = true
        }, 300)
      },
      
      showContainerInfo() {
        this.dialog = true;
        this.formWidth = 650
        this.currentForm = PostInfo
        this.formProps = {
          data: this.selectedContainer,
          type: 'container'
        }
        this.hideCtxMenu()
      },
      
      openInviteForm(){
        let post = {...this.selectedPost}
        this.$store.dispatch('orgstructure/getInvites', post.key).then(data => {
          this.dialog = true
          this.formWidth = 1000
          this.formProps = {
            invites: data.invites_data,
            post: post
          }
          this.currentForm = InviteForm
        })
        this.hideCtxMenu()
      },
      
      editPost() {
        let id = this.selectedPost.key
        this.$store.dispatch('orgstructure/getPost', id).then(data => {
          this.dialog = true
          this.formWidth = 1000
          this.formProps = {
            'edit-mode': true,
            dialog: this.dialog,
            data: data.post,
            container_tree: data.containers_tree
          }
          this.currentForm = NewPostForm
        })
        this.hideCtxMenu()
      },
      
      deletePost(){
        let id = this.selectedPost.key
        this.dialog = true
        this.formWidth = 1000
        this.formProps = {
          post_id: id
        }
        this.currentForm = DeleteForm
        this.hideCtxMenu()
      },
      
      dismissPost(){
        let id = this.selectedPost.key
        const container_id = this.selectedPost.container_id
        
        this.$dmsAgree({title: 'Увольнение с поста', message: 'Вы уверены, что хотите освободить данный пост?'}).then( confirm => {
          this.$store.dispatch('orgstructure/dismissPost', id).then( response => {
            let node = this.myDiagram.findNodeForKey( container_id )
            let data = node.data
            if(data!=null){
              let posts = data.posts
              
              posts.map( arr => {
                arr.map( post=>{
                  if(post.key===id){
                    post.account_id = null
                    post.photo = DEFAULT_IMG_PATH
                    post.fullname = ''
                  }
                })
              })
              
              this.myDiagram.startTransaction("dismiss post")
              this.myDiagram.model.setDataProperty(data, "posts", posts)
              this.myDiagram.commitTransaction("dismiss post")
              node.updateTargetBindings()
            }
          })
        }).catch(()=>{})
        
        this.hideCtxMenu()
      },
      
      addPost(){
        let id = this.selectedContainer.key
        this.$store.dispatch('orgstructure/getTrees', 'all').then(response => {
          this.dialog = true
          this.formWidth = 1000
          this.formProps = {
            'edit-mode':false,
            dialog: this.dialog,
            data: {
              id: "0",
              name: "",
              description: "",
              container_id: id,
              role: '',
            },
            container_tree: response.containers_tree
          }
          this.currentForm = NewPostForm
        })
        this.hideCtxMenu()
      },
  
      editContainer(){
        let id = this.selectedContainer.key
        this.$store.dispatch('orgstructure/getContainer', id).then(response => {
          this.dialog = true
          this.formWidth = 1000
          this.formProps = {
            'edit-mode':true,
            dialog: this.dialog,
            data: response.container_data,
            types: response.types,
            container_tree: response.containers_tree
          }
          this.currentForm = NewGroupForm
        })
        this.hideCtxMenu()
      },
  
      addContainer(){
        let id = this.selectedContainer.key
        this.$store.dispatch('orgstructure/getTrees', 'all').then(response => {
          this.dialog = true
          this.formWidth = 1000
          this.formProps = {
            'edit-mode':false,
            dialog: this.dialog,
            data: {
              id: 0,
              name: "",
              description: "",
              parent_id: id,
              type_id: "",
              role: ""
            },
            types: response.types,
            container_tree: response.containers_tree
          }
          this.currentForm = NewGroupForm
        })
        this.hideCtxMenu()
      },
  
      deleteContainer(){
        let id = this.selectedContainer.key
        let node = this.myDiagram.findNodeForKey( id )
        let data = node.data
  
        this.$dmsAgree({title: 'Удаление подразделения', message: 'Вы уверены, что хотите удалить подразделение?'}).then( confirm => {
          this.$store.dispatch('orgstructure/deleteContainer', id).then(response => {
            let parent = node.findTreeParentNode()
            let siblings = parent.findTreeChildrenNodes()
            let no_children = (siblings.iterator.count===1)
            
            this.myDiagram.startTransaction("remove node")
            this.myDiagram.model.setDataProperty(parent.data, 'no_children', no_children)
            this.myDiagram.model.removeNodeData(data)
            this.myDiagram.commitTransaction("remove node")
            
          })
        }).catch()
        this.hideCtxMenu()
      },
      
      changeOrgscheme(eventData){
        let data = null
        this.myDiagram.selection.each( node_item => {
          if (node_item instanceof go.Node) {
            data = node_item.data;
          }
        })
        
        if(eventData.type==='edit-post'){
          data = this.myDiagram.findNodeForKey( eventData.data.old_container ).data
        }
        
        if(data!=null){
          switch(eventData.type){
            case 'edit-container':
              this.myDiagram.startTransaction("update container")
              if ( eventData.data.parent_id && data.parent !== eventData.data.parent_id ){
                this.myDiagram.model.setParentKeyForNodeData( data, eventData.data.parent_id)
              }
              this.myDiagram.model.setDataProperty(data, "title", eventData.data.name)
              this.myDiagram.model.setDataProperty(data, "description", eventData.data.description)
              this.myDiagram.model.setDataProperty(data, "color", eventData.data.color)
              this.myDiagram.commitTransaction("update container")
              //Удалить контейнер из глобального объекта контейнеров. В связи с изменением данных. Корректные данные будут загружены по надобности.
              this.$store.commit('app/org/deleteContainer', eventData.data.id)
              break
            case 'add-container':
              const new_container = {
                key : eventData.data.id,
                title : eventData.data.name,
                description: eventData.data.description,
                parent : data.key,
                color : (eventData.data.color !== '') ? eventData.data.color : data.color,
                stroke : '#e25858',
                position: eventData.data.position,
                is_container : 1,
                no_children: true,
                show_panel : false,
                posts : []
              };
              this.myDiagram.startTransaction( "add container" )
              this.myDiagram.model.addNodeData( new_container )
              this.myDiagram.model.setDataProperty( data, "no_children", false )
              this.myDiagram.commitTransaction( "add container" )
              break
            case 'edit-post':
              let posts = [...data.posts]
              //Если подразделение не меняется - отредактировать пост
              if(eventData.data.container_id===eventData.data.old_container){
                posts.map( arr => {
                  arr.map( post => {
                    if (post.key===eventData.data.id){
                      post.title = eventData.data.name
                      post.description = eventData.data.description
                    }
                  })
                })
              } else { // Отредактировать и перенести в новое подразделение, а из старого удалить
                let all_posts = []
                posts.map( arr => {
                  all_posts = all_posts.concat(arr)
                })
                let index = all_posts.length
                let tempPostArray = []
                while (index--) {
                  if (all_posts[index].key===eventData.data.id) {
                    tempPostArray = all_posts.splice(index, 1)
                  }
                }
                let temp_posts = []
                for (let i = 0; i <Math.ceil(all_posts.length/POST_SIZE); i++){
                  temp_posts[i] = all_posts.slice((i*POST_SIZE), (i*POST_SIZE) + POST_SIZE)
                }
                posts = temp_posts
                
                const newData = this.myDiagram.findNodeForKey( eventData.data.container_id ).data
                if(newData != null){
                  let tempPost = tempPostArray[0]
                  tempPost.container_id = eventData.data.container_id
                  tempPost.title = eventData.data.name
                  tempPost.description = eventData.data.description
                  let newPosts = [...newData.posts]
                  if(newPosts.length===0) {
                    newPosts.push([tempPost])
                  } else {
                    let index = newPosts.length-1
                    if(newPosts[index].length<6){
                      newPosts[index].push(tempPost)
                    } else {
                      newPosts.push([tempPost])
                    }
                  }
                  this.myDiagram.startTransaction("move post")
                  this.myDiagram.model.setDataProperty(newData, "posts", newPosts)
                  this.myDiagram.commitTransaction("move post")
                }
              }
              
              this.myDiagram.startTransaction("update post")
              this.myDiagram.model.setDataProperty(data, "posts", posts)
              this.myDiagram.commitTransaction("update post")
              //Удалить пост из глобального объекта постов. В связи с изменением данных. Корректные данные будут загружены по надобности.
              this.$store.commit('app/org/deletePost', eventData.data.id)
              break
            case 'add-post':
              let new_post = {
                color: "#FFB74D",
                container_id: eventData.data.container_id,
                description: eventData.data.description,
                key: eventData.data.id,
                photo: DEFAULT_IMG_PATH,
                title: eventData.data.name,
                fullname: '',
                account_id: null,
                has_email: false,
                has_phone: false,
                has_function: false,
                show_panel: false
              }
  
              let posts2 = [...data.posts]
              if(posts2.length===0) {
                posts2.push([new_post])
              } else {
                let index = posts2.length-1
                if(posts2[index].length<5){
                  posts2[index].push(new_post)
                } else {
                  posts2.push([new_post])
                }
              }
  
              this.myDiagram.startTransaction("add post")
              this.myDiagram.model.setDataProperty(data, "posts", posts2)
              this.myDiagram.commitTransaction("add post")
              break
            case 'delete-post':
              let c_data = this.myDiagram.findNodeForKey( eventData.container_id ).data
              if(c_data!=null){
                let all_posts = []
                c_data.posts.map( arr => {
                  all_posts = all_posts.concat(arr)
                })
                
                all_posts = all_posts.filter( post => {
                  return post.key!==eventData.post_id
                })
                let posts = []
                for (let i = 0; i <Math.ceil(all_posts.length/POST_SIZE); i++){
                  posts[i] = all_posts.slice((i*POST_SIZE), (i*POST_SIZE) + POST_SIZE)
                }
                this.myDiagram.startTransaction("remove post")
                this.myDiagram.model.setDataProperty(c_data, "posts", posts)
                this.myDiagram.commitTransaction("remove post")
              }
              break
          }
        }
      },
      
      makeZoom(value){
        if(value>1){
          this.zoomInterval = setInterval( () => { this.myDiagram.commandHandler.increaseZoom(1.1); }, 50 )
        } else {
          this.zoomInterval = setInterval( () => { this.myDiagram.commandHandler.decreaseZoom(0.9); }, 50 )
        }
      },
      
      clearZoom(){
        clearInterval(this.zoomInterval);
      },
      
      findMyself(){
        let id = 0
        this.tree.map( container => {
          container.posts.map( arr => {
            arr.map( post => {
              if( post.key===this.postId ) id = container.key
            })
          })
        })
        const node = this.myDiagram.findNodeForKey( id );
        if( node !== null ) this.myDiagram.commandHandler.scrollToPart( node );
      },
      
      searchDiagram(){
        this.myDiagram.startTransaction("highlight search");
        
        if (this.searchText.length>0) {
          const regex = new RegExp(this.searchText, "i");
          let results = this.myDiagram.findNodesByExample({ title: regex })
  
          let results_posts = new go.List()
          //Search posts fullname and title
         
          const searchText = this.searchText.toLowerCase()
          this.myDiagram.nodes.each(function(node) {
            let posts_object = node.part.data.posts_object
    
            for (let i in posts_object) {
              let fullname = posts_object[i]["fullname"].toLowerCase()
              let title = posts_object[i]["title"].toLowerCase()
              
              if (fullname.includes(searchText) || title.includes(searchText)) {
                results_posts.add(node)
              }
            }
          })
  
          if (this.temp_result.count>0) this.clearResults(this.temp_result);
          
          if(results_posts.count>0){
            results = results.concat(results_posts)
          }
          this.temp_result = results;
          
          results.each(function(item){
            const shape = item.findObject("SHAPE");
            shape.fill = "#6DAB80";
            shape.stroke = 'red';
            shape.strokeWidth = 3;
            const text = item.findObject("TEXT");
            text.stroke = "white";
          });
          
          this.myDiagram.highlightCollection(results);
          
          // try to center the diagram at the first node that was found
          if (results.count > 0) {
            this.results_found = results.count
            this.myDiagram.centerRect(results.first().actualBounds)
          }
        } else {  // empty string only clears highlighteds collection
          this.myDiagram.clearHighlighteds();
          this.clearResults(this.temp_result);
        }
        this.myDiagram.commitTransaction("highlight search");
      },
      
      clearResults(results){
        if ( Object.keys(results).length>0 ){
          results.each(function(item){
            const shape = item.findObject("SHAPE");
            // Return the Shape's fill to the defaults
            shape.fill = item.data.color;
            shape.stroke = item.data.stroke;
            shape.strokeWidth = item.data.strokeWidth;
            // Return the TextBlock's stroke to its default
            const text = item.findObject("TEXT");
            text.stroke = "black";
          });
          this.results_found = 0
        }
        
      },
      
      scrollToPart(){
        let current_node = false
        this.temp_result.first();
        let k = 1;
        while (this.temp_result.next()) {
          let item = this.temp_result.value
          if (k===this.current){
            current_node = item
          }
          k++;
        }
        if(current_node) this.myDiagram.commandHandler.scrollToPart(current_node)
      },
      
      navigateSearch(type){
        if(type==='prev' && Object.keys(this.temp_result).length>0){
          this.current--
          if (this.current<1) this.current=this.temp_result.count
        } else if(type==='next' && Object.keys(this.temp_result).length>0) {
          this.current++
          if (this.current>this.temp_result.count) this.current=1
        }
        this.scrollToPart()
      },
  
      debouncedSearch: _.debounce(function () {
        this.searchDiagram()
      }, 1000),
    },
  
    watch: {
      searchText: function () {
        this.debouncedSearch()
      }
    },
  
  }
</script>

<style>
  #orgsheme #overview {
    position: absolute;
    top: 10px;
    left: 10px;
    background-color: aliceblue;
    z-index: 3; /* make sure its in front */
    border: solid 1px blue;
    width: 200px;
    height: 100px
  }
  
  .hierarchy_zoom_buttons {
    top: 160px;
    z-index: 3;
    right: 5px;
    position: fixed;
    background: white;
  }
  
  #OrgSchemeContextMenu:focus, #OrgSchemePostContextMenu:focus{
    outline: none;
  }

  #OrgSchemePostContextMenu ul p.postTitle{
    border-bottom: 1px solid;
    padding: 6px 0;
    margin: 0;
  }
  
  #OrgSchemeContextMenu ul, #OrgSchemePostContextMenu ul{
    background: #fff;
    border: 1px solid #bebebe;
    border-radius: .2em;
    padding: 0;
    list-style: none;
    -webkit-box-shadow: 0 2px 5px rgba(0, 0, 0, .5);
    box-shadow: 0 2px 5px rgba(0, 0, 0, .5);
  }
  
  #OrgSchemeContextMenu li, #OrgSchemePostContextMenu li {
    margin: 4px 0;
    padding: 4px 15px 4px 9px;
    color: #2f2f2f;
  }
  
  #OrgSchemeContextMenu li:hover, #OrgSchemePostContextMenu li:hover {
    color: #fff;
    cursor: pointer;
    background-color: #d5d5d5;
  }
  
  #OrgSchemeContextMenu li i.mdi, #OrgSchemePostContextMenu li i.mdi {
    font-size: 17px;
    margin-right: 5px;
    width: 18px;
  }
  
  #mySearch {
    border-style: inset;
    height: 30px;
  }
  
  .search-block{
    text-align: right;
    margin: 10px 8px;
    position: fixed;
    right: 0;
    padding-left: 15px;
    background: white;
    z-index: 3;
  }
  
  .search-nav-btns{
    width: 30px;
    height: 30px;
    margin: 3px 3px 7px 3px;
  }
  
  canvas:active, canvas:focus {
    outline: none;
  }
</style>


// WEBPACK FOOTER //
// src/apps/org/components/Orgschema/Orgschema.vue